'use strict';

var constants = require('../constants');

function lower(word) {
    return word.toLowerCase();
}

function matchLowers(dataLocale) {
    return constants.SUPPORTED_LOCALES.map(lower).indexOf(dataLocale.toLowerCase()) > -1;
}

function getLocale(locale, dataLocale) {
    var loc = locale || constants.DEFAULT_LOCALE;
    if (dataLocale) {
        if (matchLowers(dataLocale)) {
            loc = dataLocale;
        } else {
            loc = constants.DEFAULT_LOCALE;
        }
    }
    return loc;
}

module.exports = getLocale;


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/locale.js
 ** module id = 11
 ** module chunks = 0
 **/